import { getEnvironmentData } from '@b2x/shared/utilities.mjs';

import { getAuthenticationState, setLegacyStorageValues } from '@/utilities/helpers';
import { logger } from '@/utilities/logger';

import { initializeLoginActionsLibrary } from './initialize';

const log = logger.createLogger('BOOTSTRAP');

async function bootstrap() {
  log.info(`Login Actions library ${VERSION} - ${BUILD_TIME}`);
  const { country } = (await getEnvironmentData('login-actions')).pageEnvironmentVariables;
  const authState = await getAuthenticationState();

  setLegacyStorageValues(authState);

  if (!authState.isLoggedIn) {
    return;
  }

  initializeLoginActionsLibrary(country, authState);
}

await bootstrap();
